module.exports = __webpack_public_path__ + "img/resource-tech-image-16.61e4bfc0.jpg";